


































import { Component, Vue, Prop } from 'vue-property-decorator';
import { GET_PROJECT } from './getProject';

@Component
export default class ProjectShow extends Vue {
  public GET_PROJECT = GET_PROJECT;
  @Prop(String) public id!: string;
}
